import { Box, Chip, Divider, Typography } from '@mui/material';
import { CommonDialog, CommonDialogHeader } from '..';
import { IAdminUser } from '../../../types/store';

interface Props {
  selectedUser: IAdminUser;
  isOpenDialog: boolean;
  setIsOpenDialog: (open: boolean) => void;
}

const Field = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <Box>
    <Typography variant="caption" color="text.secondary" fontWeight={600}>
      {label}
    </Typography>
    <Typography variant="body2" mt={0.25}>
      {value ?? '—'}
    </Typography>
  </Box>
);

const formatDate = (val?: string) => {
  if (!val) return '—';
  return new Date(val).toLocaleString();
};

export const ViewAdminUserDialog = ({ selectedUser, isOpenDialog, setIsOpenDialog }: Props) => {
  return (
    <CommonDialog
      isOpen={isOpenDialog}
      header={
        <CommonDialogHeader
          title={`User — ${selectedUser.username}`}
          onClose={() => setIsOpenDialog(false)}
        />
      }
      body={
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
          <Box display="flex" gap={1} alignItems="center">
            <Chip
              label={selectedUser.enabled ? 'Active' : 'Inactive'}
              color={selectedUser.enabled ? 'success' : 'default'}
              size="small"
            />
            {selectedUser.password_expired && (
              <Chip label="Password Expired" color="warning" size="small" />
            )}
          </Box>

          <Divider />

          <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
            <Field label="Username" value={selectedUser.username} />
            <Field
              label="Roles"
              value={
                selectedUser.roles.length > 0 ? (
                  <Box display="flex" gap={0.5} flexWrap="wrap">
                    {selectedUser.roles.map((role) => (
                      <Chip key={role.id} label={role.name} size="small" />
                    ))}
                  </Box>
                ) : null
              }
            />
            <Field label="Email" value={selectedUser.email} />
            <Field label="Phone" value={selectedUser.phone_number} />
            <Field label="Name" value={`${selectedUser.first_name} ${selectedUser.last_name}`} />
          </Box>

          <Divider />

          <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
            <Field label="Created By" value={selectedUser.created_by} />
            <Field label="Created At" value={formatDate(selectedUser.created_at)} />
            <Field label="Updated By" value={selectedUser.updated_by} />
            <Field label="Updated At" value={formatDate(selectedUser.updated_at)} />
          </Box>
        </Box>
      }
      footer={undefined}
    />
  );
};
